"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseTheme = void 0;
exports.buildTheme = buildTheme;
exports.themes = exports.theme = exports.spacingKeys = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _chromaJs = _interopRequireDefault(require("chroma-js"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var palette = {
  white: "#FFFFFF",
  black: "#000000",
  tertiary: {
    10: "#BDCFF0",
    20: "#A7BCDC",
    30: "#91A9C7",
    40: "#7E98B3",
    50: "#6D879F",
    60: "#5D768B",
    70: "#4E6577",
    80: "#405463",
    90: "#33434F",
    100: "#26323B"
  },
  grey: {
    10: "#FAFAFA",
    20: "#EEEEEE",
    30: "#E0E0E0",
    40: "#D0D0D0",
    50: "#B8B8B8",
    60: "#909090",
    70: "#686868",
    80: "#505050",
    90: "#303030",
    100: "#161616"
  },
  pink: {
    10: "#FFD9E7",
    20: "#FAA2C2",
    30: "#F075A0",
    40: "#EB5E8E",
    50: "#E2467C",
    60: "#D1366A",
    70: "#B81C50",
    80: "#91133D",
    90: "#6B0A2B",
    100: "#47061C"
  },
  purple: {
    10: "#E3DEFF",
    20: "#C6BAFB",
    30: "#A491F6",
    40: "#9279ED",
    50: "#8060E0",
    60: "#7046CF",
    70: "#6035A8",
    80: "#4D2480",
    90: "#3D185E",
    100: "#2E0C45"
  },
  blue: {
    10: "#B8F3FF",
    20: "#84E0F5",
    30: "#3CC8F0",
    40: "#26ADE4",
    50: "#2190CF",
    60: "#1E71BD",
    70: "#1B55A6",
    80: "#153A85",
    90: "#112869",
    100: "#010E42"
  },
  green: {
    10: "#CFF0A6",
    20: "#A8D96E",
    30: "#8AC24A",
    40: "#6FAC2E",
    50: "#57951B",
    60: "#417E0F",
    70: "#2F6807",
    80: "#1F5103",
    90: "#123A01",
    100: "#092400"
  },
  orange: {
    10: "#FFECA6",
    20: "#FBD467",
    30: "#F3B01C",
    40: "#E99B0C",
    50: "#D98601",
    60: "#C47400",
    70: "#A86100",
    80: "#874C00",
    90: "#653800",
    100: "#4D2A00"
  },
  red: {
    10: "#FFD0C4",
    20: "#F78F72",
    30: "#F25F33",
    40: "#EB4C17",
    50: "#D6420D",
    60: "#C93C08",
    70: "#B83504",
    80: "#992C02",
    90: "#7A2301",
    100: "#661D00"
  }
};
var defaultRadius = {
  min: "0px",
  sm: "4px",
  md: "8px",
  lg: "16px",
  xl: "32px",
  xxl: "64px",
  max: "50%"
};
var spacingKeys = {
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  8: "8",
  10: "10",
  12: "12"
};
exports.spacingKeys = spacingKeys;
var baseTheme = {
  fonts: {
    main: "'Work Sans', sans-serif"
  },
  colors: {
    primary: "#262f3d",
    secondary: "#00cc88",
    actionsPrimary: "#00cc88",
    actionsSecondary: "#5d768b",
    white: "#ffffff",
    textPrimary: "#262f3d",
    textSecondary: "#686868",
    textLight: "#909090",
    borders: "#e0e0e0",
    dividers: "#e0e0e0",
    disabled: "#eeeeee",
    background: "#fafafa",
    elevationBackground: "#ffffff",
    success: "#417e0f",
    error: "#c93c08",
    warn: "#c93c08",
    title: "#505050",
    overlay: "#262f3d",
    overlayText: "#ffffff",
    warn2: "#c47400",
    ai: "#673ab7"
  },
  radius: defaultRadius,
  shadow: {
    xs: "0 1px 2px rgba(0,0,0,0.10), 0 1px 2px rgba(0,0,0,0.20)",
    sm: "0 1px 3px rgba(0,0,0,0.12), 0 1px 3px rgba(0,0,0,0.24)",
    md: "0 3px 6px rgba(0,0,0,0.10), 0 3px 6px rgba(0,0,0,0.15)",
    xl: "0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 5px 5px -3px rgba(0, 0, 0, 0.2)"
  },
  placeholder: {
    color: "#e0e0e0",
    textColor: "#B8B8B8"
  },
  breakPoints: {
    xs: 480,
    sm: 960,
    md: 1024,
    lg: 1260
  },
  zIndex: {
    modal: 1000,
    topBar: 100
  },
  dir: "ltr",
  mode: "light",
  palette: palette,
  spacing: {
    1: "4px",
    2: "8px",
    3: "12px",
    4: "16px",
    5: "20px",
    6: "24px",
    8: "32px",
    10: "40px",
    12: "48px"
  }
};
exports.baseTheme = baseTheme;
var lightTheme = baseTheme;
var darkTheme = _objectSpread(_objectSpread({}, baseTheme), {}, {
  colors: _objectSpread(_objectSpread({}, baseTheme.colors), {}, {
    primary: "#e0e0e0",
    actionsSecondary: "#91a9c7",
    white: "#303030",
    textPrimary: "#e0e0e0",
    textSecondary: "#d0d0d0",
    borders: "#505050",
    dividers: "#505050",
    disabled: "#505050",
    background: "#161616",
    elevationBackground: "#404040",
    success: "#6fac2e",
    error: "#eb4c17",
    title: "#e0e0e0",
    overlay: "#505050",
    overlayText: "#ffffff",
    warn2: "#e99b0c",
    ai: "#9279ed"
  }),
  placeholder: {
    color: "#505050",
    textColor: "#B8B8B8"
  },
  mode: "dark"
});
var themes = {
  light: lightTheme,
  dark: darkTheme
};
exports.themes = themes;
var theme = themes.light; // Deprecated, use themes.light
exports.theme = theme;
function buildTheme(theme) {
  // For light mode, elevation background and background are the same thanks to the box-shadow,
  // For dark mode, as we can hardly see the box-shadow, the elevation background must be brighter than the background, hence come this adjustment
  return _objectSpread(_objectSpread({}, theme), {}, {
    colors: _objectSpread(_objectSpread({}, theme.colors), {}, {
      elevationBackground: (0, _chromaJs.default)(theme.colors.background).brighten(theme.mode === "dark" ? 1.04 : 0.1).hex()
    })
  });
}
function ThemeProvider(_ref) {
  var children = _ref.children,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? themes.light : _ref$theme;
  return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: buildTheme(theme)
  }, children);
}
var _default = ThemeProvider;
exports.default = _default;
//# sourceMappingURL=index.js.map